import * as React from 'react';
import { useTranslationHook } from 'PyzShopUi/scripts/utils/translationHook';
import ProductBasicPrice from '../../shop-ui/components/product-item/ProductBasicPrice';
import FormattedCurrency from '../../react/common/components/FormattedCurrency';
import { FootnoteManager } from 'PyzShopUi/scripts/modules/footnote';

export interface IOrderContainerProps {
    amount: number;
    originalAmount: number;
    basicPrice?: any;
    currency: string;
}

export const B2BOrderContainer: React.FunctionComponent<IOrderContainerProps> = props => {
    const { amount, originalAmount, basicPrice, currency } = props;
    const { translate } = useTranslationHook();

    const footnoteUvpNumberRef = React.useRef<number>(FootnoteManager.getInstance().getFootnoteNumber(FootnoteManager.uvp));

    return (
        <div className="article-price">
            {
                <div className="heading4">
                    {translate('RRP', { ns: 'article-detail' })}
                    <span>
                        &nbsp;
                        <FormattedCurrency price={originalAmount / 100} currency={currency} footnoteNumber={footnoteUvpNumberRef.current} />
                        <sup>

                        </sup>
                    </span>
                </div>
            }
            <span className="heading1">
                <FormattedCurrency price={amount / 100} currency={currency} />
            </span>
            {
                basicPrice ?
                    <div className="base-price">
                        <ProductBasicPrice
                            displayLabel
                            currency={currency}
                            unitName={basicPrice.unit_name}
                            unitAmount={basicPrice.unit_amount}
                            unitValue={basicPrice.unit_value} />
                    </div>
                    : undefined
            }
        </div>
    );
};
